import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import "./Navbar.css";

function Navbar({ isMenuOpen, setIsMenuOpen }) {
  const [activeLink, setActiveLink] = useState("about");
  const [isScrolled, setIsScrolled] = useState(false);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsMenuOpen(false); // Close the menu when a link is clicked
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="logo">
        <img
          src={`${process.env.PUBLIC_URL}/Images/Hi-Logo.png`}
          alt="Company Logo"
          style={{ width: "120px", height: "auto" }}
        />
      </div>

      <div className="nav-links-container">
        <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <li>
            <Link
              to="about"
              smooth={true}
              duration={500}
              onClick={() => handleLinkClick("about")}
              className={activeLink === "about" ? "active" : ""}
            >
              HOME
            </Link>
          </li>
          <li>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              onClick={() => handleLinkClick("contact")}
              className={activeLink === "contact" ? "active" : ""}
            >
              CONTACT US
            </Link>
          </li>
        </ul>
      </div>

      <div
        className={`hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {isMenuOpen && (
        <div className="mobile-menu">
          <div className="close-button" onClick={() => setIsMenuOpen(false)}>
            <img
              src={`${process.env.PUBLIC_URL}/Images/Close Symbol.svg`}
              className="svg-icon"
              style={{
                width: "20px",
                height: "auto",
                position: "absolute",
                top: "5px",
                right: "5px",
                marginRight: "10px",
              }}
              alt="Close Symbol"
            />
          </div>
          <ul className="mobile-nav-links">
            <li>
              <Link
                to="about"
                smooth={true}
                duration={500}
                onClick={() => handleLinkClick("about")}
              >
                HOME
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                onClick={() => handleLinkClick("contact")}
              >
                CONTACT US
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
